import { Action } from '@ngrx/store';

import { IMemberEventsDate } from '@shared/shared/interfaces/member-event.interfaces';
import { IStringValuePayload } from '@shared/store/interfaces/store.interfaces';

// Get Event Date
export const GET_EVENT_DATE = '[Member Event] Get Event Date';
export const GET_EVENT_DATE_SUCCESS = '[Member Event] Get Event Date Success';
export const GET_EVENT_DATE_FAILURE = '[Member Event] Get Event Date Failure';

export class GetEventDate implements Action {
  readonly type = GET_EVENT_DATE;

  constructor(public payload: number | string) {}
}

export class GetEventDateSuccess implements Action {
  readonly type = GET_EVENT_DATE_SUCCESS;

  constructor(public payload: IMemberEventsDate) {}
}

export class GetEventDateFailure implements Action {
  readonly type = GET_EVENT_DATE_FAILURE;

  constructor(public payload: IStringValuePayload) {}
}

export type MemberEventDateActions = GetEventDate | GetEventDateSuccess | GetEventDateFailure;
